/* eslint-disable react-hooks/exhaustive-deps */
import ScrollToTopOnMount from '../components/ScrollToTopOnMount';
import Title from '../components/Title';

import { useEffect, useState, useCallback } from 'react';
import ImageViewer from 'react-simple-image-viewer';
import { useNavigate, useParams } from 'react-router-dom';
import useNews from '../services/service.news';
import { news } from '../typings/news';
import { INITIAL_NEWS } from '../consts/common';
import useStore from '../store/selectors/useStore';

import { getLocaleProperty } from '../utils/getLocaleProperty';
import '../utils/i18next';
import useBindActionCreators from '../hooks/useBindActionCreators';
import { languageActions } from '../store/slices/languageSlice';
import { imageSrc } from '../helpers/imageSrc';
import { setTitle } from '../store/slices/titleSlice';
import { useDispatch } from 'react-redux';

function NewsInside() {
	const { language } = useStore();
	const { getNews } = useNews();
	let { id: newsId } = useParams();
	const [currentNews, setCurrentNews] = useState<any>();
	const [currentImage, setCurrentImage] = useState(0);
	const [isViewerOpen, setIsViewerOpen] = useState(false);
	const navigate = useNavigate();
	const _baseUrl = `${process.env.REACT_APP_API_URL}/storage/`;
	const dispatch = useDispatch();
	const boundCreators = useBindActionCreators({ ...languageActions });
	const { setLanguage } = boundCreators;
	const openImageViewer = useCallback((index: number) => {
		setCurrentImage(index);
		setIsViewerOpen(true);
	}, []);

	const closeImageViewer = () => {
		setCurrentImage(0);
		setIsViewerOpen(false);
	};

	let translationSlug;

	let checkIfLanguageCreated = (currentNews: {
		article: { translations: any[] };
	}) => {
		return currentNews.article?.translations?.some(
			(el: { language: { code: string } }) => el.language.code === language
		);
	};
	useEffect(() => {
		if (newsId && !currentNews) {
			getNews(newsId, language).then((news) => {
				setCurrentNews(news);
				dispatch(setTitle(news.title));
			});
			setLanguage(currentNews?.language?.code);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (
			language !== currentNews?.language?.code &&
			currentNews &&
			checkIfLanguageCreated(currentNews)
		) {
			translationSlug = currentNews?.article?.translations?.filter(
				(el: { language: { code: string }; slug: string }) => {
					if (el.language.code === language) {
						return el;
					}
				}
			);
			getNews(
				`${
					translationSlug[0]?.slug ? translationSlug[0]?.slug : currentNews.slug
				}`,
				language
			).then((news) => {
				setCurrentNews(news);
				dispatch(setTitle(news.title));
			});
			navigate(
				`/news/${
					translationSlug[0]?.slug ? translationSlug[0]?.slug : currentNews.slug
				}`,
				{ replace: true }
			);
		}
	}, [
		currentNews?.article?.translations,
		currentNews?.language?.code,
		language,
		translationSlug,
	]);

	useEffect(() => {
		return () => {
			dispatch(setTitle(''));
		};
	}, []);

	return (
		<section className="news-inside">
			<ScrollToTopOnMount />
			<div className="container">
				<div className="news-inside__body">
					<Title size="middle" uppercase className="news-inside__title">
						{currentNews?.title}
					</Title>
					<span className="news-list__date news-inside__date">
						{currentNews?.article?.updatedAt
							.slice(0, 10)
							.split('-')
							.reverse()
							.join('-')
							.replaceAll('-', '.')}
					</span>
					<div
						className="news-inside__image"
						onClick={() => openImageViewer(0)}
					>
						{currentNews && (
							<img src={`${imageSrc(currentNews)}`} alt={currentNews?.title} />
						)}
					</div>
					{isViewerOpen && (
						<ImageViewer
							src={[`${_baseUrl}${currentNews?.image?.large.path}`]}
							currentIndex={currentImage}
							disableScroll={true}
							closeOnClickOutside={true}
							onClose={closeImageViewer}
						/>
					)}
					<div
						className="news-inside-content"
						contentEditable="false"
						dangerouslySetInnerHTML={{
							__html: currentNews?.body,
						}}
					/>
				</div>
			</div>
		</section>
	);
}

export default NewsInside;
